<template>
  <div class="fill-height d-flex flex-column">
    <v-card
      class="position-relative flex-grow-1 rounded-lg d-flex flex-row align-center mb-2" light
      style="box-shadow: 0 4px 5px -1px rgba(0, 0, 0, .05); border: 1px solid rgba(0, 0, 0, .08)"
    >
      <router-link :to="`/${$store.state.merchant.slug}/item/${item.slug}`" class="position-relative d-flex pa-2">
        <ProxyImage :src="item.primary_picture" width="100px"/>
        <div class="in-cart-indicator absolute center-x-y" v-if="$store.getters['cart/inCart'](item)">
          <v-avatar color="green lighten-2" size="30">
            <v-icon color="white" small>mdi-cart-arrow-down</v-icon>
          </v-avatar>
        </div>
      </router-link>
      <div class="px-3 py-3 px-md-4 flex-grow-1 d-flex flex-column align-start justify-center">
        <v-chip class="px-2 mb-2" color="red" dark v-if="!item.quantity" x-small>Out of stock</v-chip>
        <div class="d-flex flex-column align-start justify-center fill-width mb-2" v-if="discount && item.quantity">
          <v-chip class="px-2" color="blue" dark small>Save {{ discount.percentage }}%</v-chip>
          <div class="d-flex mt-2" v-if="discount.end">
            <v-card class="pa-1 d-flex flex-row text-center" outlined>
              <div class="text-caption font-weight-bold">{{ timer.days }}</div>
              <div class="ma-0 ml-1 pa-0 text-caption" style="line-height: 1">days</div>
            </v-card>
            <v-card class="pa-1 ml-1 d-flex flex-row text-center" outlined>
              <div class="text-caption font-weight-bold">{{ timer.hours }}</div>
              <div class="ma-0 ml-1 pa-0 text-caption" style="line-height: 1">hrs</div>
            </v-card>
            <v-card class="pa-1 ml-1 d-flex flex-row text-center" outlined>
              <div class="text-caption font-weight-bold">{{ timer.minutes }}</div>
              <div class="ma-0 ml-1 pa-0 text-caption" style="line-height: 1">mins</div>
            </v-card>
            <v-card class="pa-1 ml-1 d-flex flex-row text-center" outlined>
              <div class="text-caption font-weight-bold">{{ timer.seconds }}</div>
              <div class="ma-0 ml-1 pa-0 text-caption" style="line-height: 1">secs</div>
            </v-card>
          </div>
        </div>
        <div :title="item.name" class="text-title black--text text-body-2 mb-1 fill-width">{{ item.name }}</div>
        <div class="d-flex justify-space-between fill-width">
          <div class="mt-1 fill-width">
            <div class="text-title black--text text-body-2 font-weight-bold" v-if="item.sell_on_credit === 1">
              <small class="text-strikethrough mr-2 grey--text" v-if="discount">
                {{ (item.credit_price || item.price) / item.no_of_months | currency }}
              </small>
              {{ monthly_amount | currency }} / mo • {{ item.no_of_months }} month(s)
            </div>
            <div class="text-title black--text text-body-2" v-if="item.sell_on_credit === 0">
              {{ price | currency }}
            </div>
            <div class="d-flex align-center justify-space-between fill-width mt-2">
              <v-rating
                :value="rating" background-color="orange lighten-3" color="orange" dense readonly size="15"
                v-if="$store.getters['merchant/theme'].show_product_ratings && $vuetify.breakpoint.mdAndUp"
              ></v-rating>
              <v-btn
                @click="add()" color="grey lighten-3" elevation="0"
                small v-if="item.quantity"
              >
                <v-icon class="mr-1" color="primary" size="12">mdi-cart-plus</v-icon>
                Add to cart
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import card from "../../../mixins/items/card";
import ProxyImage from "../../ProxyImage";

export default {
  name: "ItemCardHorizontal",
  components: { ProxyImage },
  mixins: [card],
}
</script>
